<template>
  <section class="admin-content" id="contact-search">
    <Navbar/>
    <main class="admin-main">

      <!-- ── Page Header ─────────────────────────────────────── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-briefcase" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Enrollment Officers</h4>
              <small style="opacity: .8;">{{ officers.meta.total }} enrollment officers</small>
            </div>
            <div class="ml-auto">
              <button type="button" class="btn btn-light btn-sm font-weight-bold px-4" @click="show = !show">
                <i class="fe mr-1" :class="show ? 'fe-minus' : 'fe-plus'"></i>
                {{ show ? 'Cancel' : 'Add Officer' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <div class="card action-card shadow mb-4">
          <div class="card-body py-3 px-4">
            <download-excel :data="json_data" :fields="json_fields" class="btn btn-sm btn-outline-success"
                           :escapeCsv=false>
              <i class="fe fe-download mr-1"></i> Download Officer Data
            </download-excel>
          </div>
        </div>

        <!-- ── Add Officer Form ───────────────────────────────── -->
        <div v-show="show" class="card form-card shadow mb-4">
          <div class="form-card-header">
            <div class="section-number">1</div>
            <h6 class="mb-0 font-weight-bold text-white">Register New Officer</h6>
          </div>
          <div class="card-body px-4 pt-4 pb-3">
            <div class="form-row">

              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">First Name</label>
                <input type="text" required class="form-control" placeholder="First Name" v-model="register.firstname">
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Last Name</label>
                <input type="text" required class="form-control" placeholder="Last Name" v-model="register.lastname">
              </div>

              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Phone Number</label>
                <input v-phone type="text" required class="form-control" placeholder="Phone Number" v-model="register.phone_number">
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Email</label>
                <input type="email" required class="form-control" placeholder="Email" v-model="register.email">
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Password</label>
                <input type="password" required class="form-control" placeholder="Password" v-model="register.password">
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Confirm Password</label>
                <input type="password" required class="form-control" placeholder="Confirm Password" v-model="register.password_confirmation">
              </div>
            </div>

            <div class="d-flex justify-content-end">
              <button @click="registerUser" class="btn btn-submit px-5">
                <i class="fe fe-send mr-2"></i> Add Officer
              </button>
            </div>
          </div>
        </div>

        <!-- ── Officers Table ──────────────────────────────────── -->
        <div class="card table-card shadow">
          <div class="d-flex align-items-center justify-content-between px-4 pt-4 pb-3">
            <div>
              <h6 class="mb-0 font-weight-bold text-dark">
                <i class="fe fe-users text-primary mr-2"></i> Officers
              </h6>
              <small class="text-muted">{{ officers.meta.total }} record(s)</small>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table mb-0">
              <thead class="table-head">
                <tr>
                  <th class="table-th px-4">Name</th>
                  <th class="table-th">Email</th>
                  <th class="table-th">Contact</th>
                  <th class="table-th">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="tpa in officers.data" v-bind:key="tpa.id" class="table-row">
                  <td class="px-4 py-3">
                    <div class="d-flex align-items-center" style="gap: 10px;">
                      <div class="employee-avatar">
                        {{ (tpa.firstname || '?')[0].toUpperCase() }}
                      </div>
                      <p class="mb-0 font-weight-bold" style="font-size: .88rem;">
                        {{ tpa.firstname }} {{ tpa.lastname }}
                      </p>
                    </div>
                  </td>
                  <td class="py-3" style="font-size: .88rem;">{{ tpa.email }}</td>
                  <td class="py-3" style="font-size: .88rem;">{{ tpa.phone_number }}</td>
                  <td class="py-3">
                    <button type="button" class="btn btn-sm btn-outline-primary">
                      <i class="fe fe-eye mr-1"></i> View
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="d-flex justify-content-center py-3" style="gap: 8px;">
              <button class="btn btn-sm btn-outline-secondary" @click="gotoPrevious">
                <i class="fe fe-arrow-left mr-1"></i> Previous
              </button>
              <button class="btn btn-sm btn-outline-secondary" @click="gotoNext">
                Next <i class="fe fe-arrow-right ml-1"></i>
              </button>
            </div>
          </div>
        </div>

      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </main>
   </section>
</template>

<script>
  import Navbar from '@/views/Navbar.vue'
  // Import component
     import Loading from 'vue-loading-overlay';
     // Import stylesheet
     import 'vue-loading-overlay/dist/vue-loading.css';
     // Init plugin


export default {
  components: {
     Navbar, Loading
  },
  data(){
    return{
      user:null,
      orgDetails:"",
      edit:false,
      show:false,
      isLoading: false,
      fullPage: true,
      officers:"",
      current_page:1,
      register:{

                email:"",
                firstname:"",
                lastname:"",
                phone_number:"",
                state:"",
                agency_name:"",
                ward:"",
                services_offered:"",
                localgovt:"",
                address1:"",
                role:0,
                password:"",
                password_confirmation:""
            },
       json_fields: {
                'Firstname':'firstname',
                'Lastname':'lastname',
                'Email	': 'email',
                'Phone Number':'phone_number'},
                json_data: [],
                json_meta: [
                [
                    {
                    key: "charset",
                    value: "utf-8",
                    },
                ]],
    }
  },
  beforeMount(){
    this.user = JSON.parse(localStorage.getItem('user'))
    this.axios.get(`/api/v1/auth/orgenrollment`)
                .then(response => {
                    this.tpas = response.data.data
                })
                .catch(error => {
                    console.error(error);
                })
  },
  methods:{
    gotoNext(){
      if (this.officers.meta.current_page != this.officers.meta.last_page) {
            this.current_page ++
            this.getOrgDetails()
          }
          else {
            this.$toasted.info('You have reached the Last Page', {position: 'top-center', duration:3000 })

          }
    },
    gotoPrevious(){
      if (this.officers.meta.current_page != 1) {
          this.current_page --
          this.getOrgDetails()
        }
        else {
          this.$toasted.info('You have reached the First Page', {position: 'top-center', duration:3000 })
        }
    },
    registerUser(){
      this.user = JSON.parse(localStorage.getItem('user'))
        this.isLoading = true;
        this.axios.post('/api/v1/auth/registerProvider',{
          email : this.register.email,
          phone_number : this.register.phone_number,
          agency_name : this.register.agency_name,
          firstname : this.register.firstname,
          lastname : this.register.lastname,
          state : '2679',
          localgovt : '631',
          type : 'tpa_employee',
          password : this.register.password,
          password_confirmation : this.register.password_confirmation,
          enrolled_by : 0,
        })
        .then(response=>{
          let agent_id = response.data.data.id

            // add Organization
              this.show = false;
              // console.log(response)
              this.axios.post('/api/v1/auth/enrollment_user',{
                orgenrol_id : this.orgDetails.id,
                user_id : agent_id,

                  })

                  .then(response=>{
                      console.log(response);
                      this.getEmployees()
                      this.clearIt()
                      this.$toasted.info('Agent added Successfully!', {position: 'top-left', duration:5000 })

                  })
                  .catch(error=>{
                      console.log(error.response)
                      this.$toasted.error('Oops!', {position: 'top-left', duration:5000 })

                  })
                  // end of provider

            // console.log(response);
            this.isLoading = false;
            // localStorage.setItem('jwt',token);
            this.getEmployees()

        })
        .catch(()=>{
            // console.log(error.response)
            this.isLoading = false;
            this.$toasted.error('Sign up not Successful', {position: 'top-left', duration:5000 })

        })
    },
    getOrgDetails(){
      this.user = JSON.parse(localStorage.getItem('user'))
      this.axios.get(`/api/v1/auth/getOrgDetails/${this.user.id}`)
                  .then(response => {
                      this.orgDetails = response.data
                      let org_id = response.data.id

                      // get officers
                      this.axios.get(`/api/v1/auth/enrollment_user/${org_id}`,{
                      params:{
                        page: this.current_page
                      }
                    })
                        .then(response => {
                            this.officers = response.data
                            this.getTotalEmployees();
                            // console.log(response)
                        })
                        .catch(() => {
                            // console.error(error);
                        })
                      //end of get officers

                      // console.log(response)
                  })
                  .catch(() => {
                      // console.error(error);
                  })
    },
    getEmployees(){
      this.axios.get(`/api/v1/auth/enrollment_user/${this.orgDetails.id}`)
        .then(response => {
            this.officers = response.data
            // console.log(response)

        })
        .catch(error => {
            console.error(error);
        })
    },
    getTotalEmployees(){
      console.log(this.officers.meta.total);
      console.log("this button is working");
      this.axios.get(`/api/v1/auth/enrollment_userall/${this.orgDetails.id}`)
        .then(response => {
            // this.officers = response.data
            this.json_data = response.data.data;
            console.log(this.json_data);
            // console.log(response)
        })
        .catch(error => {
            console.error(error);
        })
    },

    clearIt(){
      this.register.firstname = "";
      this.register.lastname = "";
      this.register.email = "";
      this.register.phone_number = "";
      this.register.password = "";
      this.register.password_confirmation = "";
    },

  },
  created(){
    this.getOrgDetails()
  }

}
</script>
